export default {"src":"/_next/static/media/0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a.652cee79.svg","height":108,"width":108,"blurWidth":0,"blurHeight":0};